document.addEventListener("DOMContentLoaded", () => {
  const variantIdInput = document.querySelector(
    'form[action*="/cart/add"] [name="id"]'
  );

  const fire = () => {
    if (!variantIdInput) return;
    variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
    variantIdInput.dispatchEvent(new Event("input", { bubbles: true }));
  };

  // Force AMP to pick up initial variant
  fire();

  // Watch for variant ID changes
  const obs = new MutationObserver(fire);
  if (variantIdInput) {
    obs.observe(variantIdInput, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  // Theme variant events (Dawn + custom themes)
  document.addEventListener("variant:change", fire);
});